import { buttonClassNames } from '@components/primitives/Button'
import { Icon } from '@components/primitives/Icon'
import Link from '@components/primitives/Link'
import { classMerge } from '@components/utilities/classMerge'
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight'
import Routes from '@lib/routes'
import { RoleQueryParam } from '@lib/types/RoleQueryParam'
import { useRouter } from 'next/navigation'
import { useRef } from 'react'

export default function FindPatientsButton({
  className,
  onClick,
}: {
  className: string
  onClick: () => void
}) {
  const divRef = useRef<HTMLDivElement>(null)
  const router = useRouter()

  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    const button = divRef.current
    if (!button) return

    const rect = button.getBoundingClientRect()
    const x = ((e.clientX - rect.left) / rect.width) * 100
    const y = ((e.clientY - rect.top) / rect.height) * 100

    button.style.setProperty('--mouse-x', `${x}%`)
    button.style.setProperty('--mouse-y', `${y}%`)
  }

  const divClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.preventDefault()
    onClick()
    router.push(Routes.signUp(RoleQueryParam.Researcher))
  }

  return (
    <div
      className={classMerge(
        buttonClassNames.primary.blueFancyGradient,
        'cursor-pointer',
        className,
      )}
      onClick={divClick}
      onMouseMove={handleMouseMove}
      ref={divRef}
      style={{ '--mouse-x': '50%', '--mouse-y': '50%' } as React.CSSProperties}
    >
      <Link href={Routes.signUp(RoleQueryParam.Researcher)}>
        <p className='flex flex-row items-center font-bold text-white'>
          Find Patients
          <Icon className={'ml-2'} icon={faArrowRight} size='1x' />
        </p>
      </Link>
    </div>
  )
}
